const faqs = [
  {
    q: '555影视需要注册才能观看吗？',
    a: '完全不需要。555影视坚持免费在线观看模式，所有最新电影和高清电影资源均无需注册登录即可直接播放，打开网站就能看，真正做到零门槛观影。',
  },
  {
    q: '画质怎么样？会模糊吗？',
    a: '本站提供的高清电影全部基于高清片源压制，支持蓝光画质级别播放。配合先进的视频分发技术，确保画质清晰细腻，无论是大屏电视还是手机观看都能获得出色体验。',
  },
  {
    q: '新电影更新速度快吗？',
    a: '555影视团队每日跟踪全网最新上映的热门大片和院线新片，通常影片上线后极短时间内即可在本站找到高清片源。我们承诺每日更新，确保您不会错过任何一部值得看的新电影。',
  },
  {
    q: '手机和平板可以看吗？',
    a: '当然可以。555影视全面适配手机、平板、电脑等各类设备，无论您使用iOS还是Android系统，都能享受流畅播放的在线看电影体验，随时随地追影不设限。',
  },
];

export default function FAQSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[900px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading text-foreground-900 mb-3">
            常见问题
          </h2>
          <p className="text-foreground-500 text-sm md:text-base">
            关于555影视的使用疑问，这里为您一一解答
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((item, i) => (
            <div
              key={i}
              className="bg-background-50 rounded-xl p-5 md:p-6 border border-background-200/60"
            >
              <h3 className="text-base md:text-lg font-medium text-foreground-900 mb-2 flex items-start gap-3">
                <span className="flex-shrink-0 w-6 h-6 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 text-xs font-bold mt-0.5">
                  Q
                </span>
                {item.q}
              </h3>
              <p className="text-foreground-600 text-sm leading-relaxed pl-9">
                {item.a}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}